import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { COMPANY, SERVICES, waLink } from "../lib/constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-brand-green text-white">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link to="/" data-testid="footer-brand-link" className="inline-block leading-none" aria-label="Krishnaa Constructions, home">
            <span className="block font-heading text-xl font-black uppercase tracking-wide text-white">
              Krishnaa Constructions
            </span>
            <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.28em] text-white/70">
              All Types of Building Work
            </span>
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-white/70">
            Loft conversions, extensions, kitchens, bathrooms, electrical, plumbing and tiling — quality building work across {COMPANY.areas}.
          </p>
        </div>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">Quick Links</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[["/", "Home"], ["/about", "About Us"], ["/services", "Services"], ["/projects", "Projects"], ["/contact", "Contact"], ["/privacy", "Privacy Policy"]].map(([to, label]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="text-white/80 transition-colors hover:text-white">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">Our Services</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to="/services" data-testid={`footer-service-${s.id}`} className="text-white/80 transition-colors hover:text-white">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">Contact</h3>
          <ul className="mt-4 space-y-3.5 text-sm">
            <li>
              <a href={`tel:${COMPANY.phone}`} data-testid="footer-phone" className="flex items-center gap-2.5 text-white/85 transition-colors hover:text-white">
                <Phone className="h-4 w-4 shrink-0" /> {COMPANY.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-center gap-2.5 text-white/85 transition-colors hover:text-white">
                <Mail className="h-4 w-4 shrink-0" /> {COMPANY.email}
              </a>
            </li>
            <li>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2.5 text-white/85 transition-colors hover:text-white">
                <MessageCircle className="h-4 w-4 shrink-0" /> WhatsApp us
              </a>
            </li>
            <li className="flex items-start gap-2.5 text-white/70">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0" /> {COMPANY.areas}, United Kingdom
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/15 pt-7 text-xs text-white/60 sm:flex-row">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Krishnaa Constructions (KAC). All rights reserved.</p>
        <p>Contact: {COMPANY.contact} · {COMPANY.tagline}</p>
      </div>
    </div>
  </footer>
);
